import { combineReducers } from "redux";

const reduceFetching = (state = {}, action = null) => {
    const matches = /^GET_(.*?)(_LIST)?_(REQUEST|SUCCESS|FAILURE)$/.exec(action.type);
    if (!matches) { return state; }

    const [, actionName,, actionState] = matches;
    const index = action?.payload?.id ? `${actionName}_${action.payload.id}` : actionName;

    return {
        ...state,
        [index]: actionState === 'REQUEST'
    };
};

const reduceSending = (state = {}, action = null) => {
    const matches = /^(ADD|UPDATE|DELETE)_(.*)_(REQUEST|SUCCESS|FAILURE)$/.exec(action.type);
    if (!matches) { return state; }

    const [,, actionName, actionState] = matches;

    return {
        ...state,
        [actionName]: actionState === 'REQUEST'
    };
};

const fetching = combineReducers({
    fetching: reduceFetching,
    sending: reduceSending,
});

export default fetching;
export const isFetching = ({fetching}, dataType, id = null) => ((!id ? fetching[dataType] : fetching[`${dataType}_${id}`]) || false);
export const isSending = ({sending}, dataType) => (sending[dataType] || false);
